import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EsriPoint } from '../../../config/esri.module';
import { MainMapService } from '../../../shared/service/main-map.service';
import { DomUtilService } from '../../../shared/service/dom-util.service';
import '@arcgis/map-components/components/arcgis-scale-bar';
import { ArcgisScaleBarElement } from './arcgis-scale-element.interface';

@Component({
    selector: 'scale-bar',
    templateUrl: './scale-bar.component.html',
    standalone: false
})
export class ScaleBarComponent implements OnInit {
  @ViewChild('scaleBarRef', { static: true }) scaleBarRef: ElementRef;
  @ViewChild('scaleRef', { static: true }) scaleRef: ElementRef<ArcgisScaleBarElement>;

  private scaleBarComponent: ArcgisScaleBarElement;
  constructor(
    private _mainMapService: MainMapService,
    private _cdr: ChangeDetectorRef,
    private _domUtilService: DomUtilService
  ) {}

  ngOnInit() {

    const mapView: any = this._mainMapService.mapView;

    this.scaleBarComponent = this.scaleRef.nativeElement;
    this.scaleBarComponent.view = this._mainMapService.mapView;
    this.scaleBarComponent.unit = 'metric';
    this.scaleBarComponent.barStyle = 'line';

    // add esri widget to view
    mapView.ui.add(this.scaleBarRef.nativeElement, 'bottom-left');

    // listen to mouse move
    this._mainMapService.mapView.on('pointer-move', evt => {
      this.showCoordinates(evt);
    });
  }

  /**
   * @name showCoordinates
   * @param evt
   * @description Converts the screen-point to the map-point and shows it
   */
  private showCoordinates(evt) {
    // convert screen-point to map-point
    const screenPointProperties: __esri.PointProperties = {
      x: evt.x,
      y: evt.y,
    };
    const screenPoint: __esri.Point = new EsriPoint(screenPointProperties);
    const mapPoint: __esri.Point = this._mainMapService.mapView.toMap(screenPoint);

    // display mouse coordinates
    this._domUtilService.showCoordinates(this.scaleBarRef, mapPoint);
    this._cdr.detectChanges();
  }
}
